jQuery(document).ready(function($) {
  if(document.getElementById('keyword')){
    var search = document.getElementById('search_icon');
    var search_input = document.getElementById('search_bar');
    var search_form = document.getElementById('keyword');
  
    $(document).on('click', function(e){
      if ($(e.target).closest(".search_block").length) return;
      search_input.style.display = 'none';
    });
  
    search.addEventListener('click', function(e) {
      search_input.classList.toggle('active');
      if (search_input.classList.contains('active')) {
        search_input.style.display = 'block';
      } else {
        search_input.style.display = 'none';
        search_form.value = '';
        $("#datafetch").hide();
      }
    });
      
    search_form.addEventListener('keydown', (e) => {
      if(e.which === 13) {
        e.preventDefault();
      }
    });
  
    $("input#keyword").keyup(function() {
      if ($(this).val().length > 2) {
        $("#datafetch").addClass('active');
      } else {
        $("#datafetch").removeClass('active');
      }
    });
  }
});
